export const minimumDownPayment = 5000;
